import { FShallowNodeTypesEnum } from '../types/node.js';

import { MigrationStateV4_0_0 } from './migration-v4.0.0.js';
import { Migration, MigrationVersionEnum } from './types.js';

export type MigrationStateV4_1_0 = {
  type: FShallowNodeTypesEnum.Root;
  space: number;
  name: string | null;
  version: string;
  cursor: string | null;
  nodes: {
    [selector: string]: {
      type: number;
      id: number;
      attrs?: Record<string, any>;
      meta?: Record<string, any>;
    };
  };
};

export const migration_4_1_0: Migration<
  MigrationVersionEnum.v4_1_0,
  MigrationStateV4_0_0,
  MigrationStateV4_1_0
> = {
  version: MigrationVersionEnum.v4_1_0,
  check: (state) => state.version === MigrationVersionEnum.v4_0_0,
  migrate: (state) => {
    return {
      ...state,
      type: FShallowNodeTypesEnum.Root,
      version: MigrationVersionEnum.v4_1_0,
      nodes: Object.entries(state.nodes).reduce(
        (acc, [selector, node]) => ({
          ...acc,
          [selector]: {
            ...node,
            type: node.type === 255 ? 31 : node.type,
          },
        }),
        state.nodes
      ),
    };
  },
};
